import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import Anli from '../views/Anli.vue'
import Render from '../views/Render.vue'
import About from '../views/AboutUs.vue'
import Join from '../views/Join.vue'
import Price from '../views/Price.vue'
import News from '../views/News.vue'

Vue.use(VueRouter)

const routes = [
  // { 
  //   path: '*', 
  //   component: NotFoundComponent 
  // },
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/case',
    name: 'Anli',
    component: Anli
  },
  {
    path: '/render',
    name: 'Render',
    component: Render
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/join',
    name: 'Join',
    component: Join
  },
  {
    path: '/price',
    name: 'Price',
    component: Price
  },
  {
    path: '/news',
    name: 'News',
    component: News
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
